<div>
  <div class="font-dm-sans text-[11px] font-semibold text-lilate-dark uppercase tracking-wider mb-3"
       translate>exam-criteria-list.title</div>
  <div class="criteria-content font-dm-sans text-[13px] text-lilate-ink-soft leading-relaxed"
       [innerHTML]="displayCriteria()"></div>
</div>
